<template>
	<nav class="mb-5">
		<ol class="flex items-center flex-wrap gap-1">
			<li
				v-for="(crumb, index) in breadcrumbs"
				:key="index"
				class="flex items-center gap-1">
				<!-- Clickable crumb -->
				<router-link
					v-if="index < breadcrumbs.length - 1"
					:to="crumb.path"
					class="text-[12px] font-medium text-muted dark:text-muted-light hover:text-primary-600 dark:hover:text-primary-300 transition-colors duration-150">
					{{ crumb.label }}
				</router-link>

				<!-- Current / last crumb -->
				<span
					v-else
					class="text-[12px] font-semibold text-primary-600 dark:text-primary-400">
					{{ crumb.label }}
				</span>

				<!-- Separator -->
				<span
					v-if="index < breadcrumbs.length - 1"
					class="text-muted dark:text-muted-light/50 select-none">
					<svg
						class="w-3 h-3"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2.5"
							d="M9 5l7 7-7 7" />
					</svg>
				</span>
			</li>
		</ol>
	</nav>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";

export default {
	name: "BreadCrumbs",
	setup() {
		const route = useRoute();
		const breadcrumbs = computed(() => route.meta.breadcrumb || []);
		return { breadcrumbs };
	},
};
</script>
